import React, { useEffect } from 'react';
import { GIVING, PAGES } from '../../constants/constants';
import nl2br from 'react-nl2br';

const Giving = () => {
  const page = PAGES['giving'];
  useEffect(() => {
    document.title = page.title;
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    document.getElementById('main-content').style.margin = '0 0 0';

    return () => {
      document.getElementById('main-content').style.margin = '0 0 20px';
    };
    //eslint-disable-next-line
  }, []);
  return (
    <div className='container-fluid giving'>
      <div className='row'>
        <div className='col-sm-6 giving-image'>
          <img
            src={`/images/${GIVING.image}`}
            alt='claire jenkins with hre pet'
          />
        </div>
        <div className='col-sm-6 giving-message'>
          <div className=''>
            <h2>{GIVING.title}</h2>
            <p>{nl2br(GIVING.message)}</p>
            <p>
              More info on WIRES? Go to&nbsp;
              <a href={GIVING.link}>https://www.wires.org.au/</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Giving;
